import { createBrowserRouter } from 'react-router';
import { routeObjects } from './route-config';

type AppRouter = ReturnType<typeof createBrowserRouter>;

let router: AppRouter | undefined;

/**
 * The browser router, created on first use (never at import time: `createBrowserRouter` reads
 * `window`, and this module must stay importable on the server). Rendered by `<App>` through
 * `RouterProvider` from `react-router/dom`.
 */
export function getRouter(): AppRouter {
  if (!router) {
    router = createBrowserRouter(routeObjects);
    // Vite HMR: drop the old router's history listeners before a fresh module creates another.
    import.meta.hot?.dispose(() => {
      router?.dispose();
      router = undefined;
    });
  }
  return router;
}
